<template>
  <div v-if="listData.length>0" class="mulu_box">
    <div v-for="(item,index) in listData" :key="index" class="firstmulu">
      <div :class="['firstmulu_li']">
        <span class="sanjiao" @click="handelShow(item)">
          <svg-icon v-if="!item.show" icon-class="sanjiao" />
          <svg-icon v-else icon-class="sanjiaoxia" />
        </span>
        <span class="dian" />
        <span class="mulu_name" @click="goread(item)">{{ item.CATALOG_NAME }}</span>
        <!--<span class="num"><svg-icon icon-class="wenjian" />{{ item.CONTENT_NUMBER }}</span>-->
      </div>
      <!--<div>{{item}}</div>-->
      <div v-if="item.show">
        <div v-if="item.CHILDREN" class="zimulu">
          <div v-for="(item1,index2) in item.CHILDREN" :key="index2" class="zimulu_li">
            <span class="sanjiao" @click="handelShow(item1)">
              <svg-icon v-if="!item1.show" icon-class="sanjiao" />
              <svg-icon v-else icon-class="sanjiaoxia" />
            </span>
            <span class="zimulu_span" @click="goread(item1)"> {{ item1.CATALOG_NAME }}</span>
            <!--<span class="num"><svg-icon icon-class="wenjian" />{{ item1.CATALOG_CONTENT_SIZE }}</span>-->
            <div v-if="item1.show">
              <div v-if="item1.CHILDREN" class="zimulu">
                <div v-for="(item2,index3) in item1.CHILDREN" :key="index3" class="zimulu_li">
                  <span class="zimulu_span" @click="goread(item2)"> {{ item2.CATALOG_NAME }}</span>
                  <!--<span class="num"><svg-icon icon-class="wenjian" />{{ item1.CATALOG_CONTENT_SIZE }}</span>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list'],
  data() {
    return {
      showIndex: '',
      listData: []
    }
  },
  watch: {
    list: {
      immediate: true,
      handler: function() {
        if (this.list.length > 0) {
          var newlis = JSON.parse(JSON.stringify(this.list))
          for (var i = 0; i < newlis.length; i++) {
            newlis[i].show = true
            if (newlis[i].CHILDREN) {
              for (var j = 0; j < newlis[i].CHILDREN.length; j++) {
                newlis[i].CHILDREN[j].show = true
              }
            }
          }
          // console.log(newlis)
          this.listData = newlis
        }
      }
    }
  },
  mounted() {
    // if (this.list.length > 0) {
    //   var listData = JSON.parse(JSON.stringify(this.list))
    //   listData.forEach(a => {
    //     a.show = true
    //   })
    //   this.listData = listData
    // }
  },

  methods: {
    handelShow: function(item) {
      if (item.show) {
        item.show = false
      } else {
        item.show = true
      }
    },
    goread(item) {
      console.log(item)
      if (item.OBJECT_TYPE == 0 || item.OBJECT_TYPE == 1) {
        var openurl = ''
        if (item.OBJECT_TYPE == 0) {
          openurl = '/checkRead?id=' + item.OBJECT_ID + '&type=2'
        }
        if (item.OBJECT_TYPE == 1) {
          openurl = '/checkRead?id=' + item.OBJECT_ID + '&type=3'
        }
        window.open(openurl, 'blank')
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .mulu_box{
        padding-left: 28px;
        padding-top: 20px;
        padding-bottom: 20px;
        .firstmulu{
            /*padding: 10px 0;*/
            border-bottom: 1px dashed #e6e6e6;
            .firstmulu_li{
                height: 35px;
                line-height: 35px;
            }
            .active{
                background-color: #eae8e9;
            }
            .sanjiao{
                transition: 3s;
                color: #808080;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
            .dian{
                display: inline-block;
                height: 5px;
                width: 5px;
                background-color: #59bd5b;
                margin-right: 7px;
                margin-left: 10px;
                vertical-align: middle;
            }
            .mulu_name{
                cursor: pointer;
            }
            .num{
                float: right;
                margin-right: 30px;
                color: #cdcdcd;
                width: 35px;
                text-align: right;
            }
            .zimulu{
                overflow: hidden;
                .zimulu_li{
                    /*height: 35px;*/
                    line-height: 35px;
                    min-height: 35px;
                    overflow: hidden;
                    padding-left: 35px;
                    border-top: 1px dashed #e6e6e6;
                    cursor: pointer;
                    .zimulu_span{
                        font-size: 13px;
                        cursor: pointer;
                        &:hover{
                            color: #ed4040;
                        }
                    }
                }
            }
        }
    }
</style>
